---
date: 2024-08-13
title: Indoor= in Russian
---

The indoor= user interface if now available in Russian, thanks to [Aleksandr Petrov](https://app.transifex.com/user/profile/felispimeja/).

To translate it in your language, [go to the transifex page](https://explore.transifex.com/indoorequal/indoorequalorg/).
